<template>
  <div class="container">
    <div class="title-hero">
      <div>
        <div class="logo-container">
          <img src="@/assets/images/logo.png" />
        </div>
        <div>
          A card game with
          <a href="https://www.cryptomonkeys.cc/">CryptomonKeys!</a>
        </div>
        <div>
          <strong>
            <br />
            This is a static build of the game i.e it does not have multiplayer.
            <br />
            You can only play against the AI using the default deck
          </strong>
        </div>

        <div>
          <button class="button outlined">
            <router-link
              :to="{ name: 'GameView', query: { ai: true, static: true } }"
            >
              Single Player
            </router-link>
          </button>
        </div>
      </div>
    </div>

    <div class="info-container">
      <h1 class="title">What is MonkeyBattle?</h1>
      <p>
        MonkeyBattle is a card game with mechanics similar to CCGs like
        Hearthstone. Each player builds card decks with a central CryptomonKey.
        The class of the CryptomonKey unlocks special class-specific cards
        divided into Memes, Movies+TV, or Festive (which includes Halloween,
        Christmas, Easter etc). MonkeyStacks can also be used as playable cards.
        The objective of each game is to bring the opponent's CryptomonKey's
        health down to 0, using potassium given in each round to play cards from
        your deck. The game also has a faucet which rewards you 0.19 ban for
        every online win.
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "Home",
});
</script>

<style>
.title-hero {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title-hero button {
  margin: 2rem;
}

.logo-container {
  margin: 2rem auto;
  max-width: 600px;
}

.login-info {
  margin-bottom: 1rem;
}

.login-info a {
  text-decoration: underline;
  color: var(--bg-tertiary);
}

.login-error {
  color: var(--red-primary);
}

.info-container {
  text-align: center;
  padding-top: 1rem;
  padding-bottom: 2rem;
  background: var(--bg-secondary);
  max-width: 1000px;
  margin: auto;
}

.info-container p {
  margin: auto;
  padding-left: 1rem;
  padding-right: 1rem;
  text-align: left;
}

.nft-cards-container {
  text-align: center;
  margin-top: 2rem;
}

.nft-cards-container .links {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.links a {
  text-decoration: underline;
  color: var(--yellow-primary);
}

.nft-cards {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: auto;
  justify-content: center;
}

.nft-cards .card-container {
  margin: 1rem;
  width: 200px;
}

.nft-cards .card {
  font-size: 1.1rem;
}

.faucet {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.info-container.planned-features {
  background: inherit;
}
</style>
